<template>
    <div class="carousel_clients wow fadeInUp" data-wow-delay="0.7s">
        <div v-for="(item, i) in items" :key="i" :src="item.img"
             :class="[!item.url ? 'unlinked': '']" class="slide position-relative">
            <img :src="item.img"/>
            <a :href="item.url" target="_blank" v-if="item.url" class="position-absolute l-0 t-0 w-100 h-100 zi-1"></a>
        </div>

    </div>
</template>

<script>
export default {
    name: "carousel_clients",
    props: {
        items: Array | String | Number | Boolean | Object,
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss" scoped>
@import "../../theme/_variable.scss";
</style>

<style lang="scss">
.group_comp .carousel_clients .slick-list .slide.unlinked:hover {
  -moz-transform: none;
  transform: none;
  -webkit-box-shadow: 0px 4px 12px rgb(0 0 0 / 6%);
  box-shadow: 0px 4px 12px rgb(0 0 0 / 6%);
}

.carousel_clients {
  & .slick-list {
    margin-left: -30px;
    margin-right: -30px;
  }

  & .slick-prev {
    right: 47px !important;
  }

  & .slick-arrow {
    border: none;
    color: #fff;
    font-size: 24px;
    position: absolute;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    width: 40px;
    height: 40px;
    background: #282828 !important;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    right: 0;
    left: unset;
    top: -106px;
  }

  & .carousel_clients__descr {
    position: absolute;
    z-index: 1;
    color: white;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;

    & .carousel_clients__inside {
      width: auto;
    }
  }

  .slide {
    height: 280px;
    border: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 20px;
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0 30px;
    cursor: pointer;
    padding-bottom: 27px;

    & img {
      -o-object-fit: contain;
      object-fit: contain;
      width: 100%;
    }
  }
}
</style>
